// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1rjcoahv{padding-block:var(--ds-space-600,3pc)}._15a5nqa1{border-top-style:solid}\n._1i53muej{border-top-color:var(--ds-border,#091e4224)}\n._bfhkvuon{background-color:var(--ds-surface,#fff)}\n._o5721q9c{white-space:nowrap}\n._syaz131l{color:var(--ds-text-subtlest,#626f86)}\n._uwhke4h9{border-top-width:var(--ds-border-width,1px)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
